import Snippet from '../../components/Snippet/Snippet'
import {
    auto,
    card,
    cardHalf,
    cardWide,
    imageFull,
    imageHeader,
    literal,
    effectLiteral
} from '../../assets/code-snippets/card/snip'


const Card = () => {

    return <div className='row'>
        <div className='col md-I sticky order-last menu-column'>
            <div className="side-menu">
                <p className="text md bold danger">`POKE-CSS`</p>
                <p className="text xs">on this page</p>
                <ul className="primary-list">
                    <li><a href="#sizes">-Sizes-</a></li>
                    <li><a href="#auto">-Auto-</a></li>
                    <li><a href="#row">-Card row-</a></li>
                    <li><a href="#image-header">-Image Header-</a></li>
                    <li><a href="#image">-Image Card-</a></li>
                    <li><a href="#glass-effect">-Glass effect-</a></li>
                </ul>
            </div>
        </div>
        <div className='col md-V content-column'>

            <div className="container fluid pb-1 pt-3" id="basics">
                <p className="text xl"><a className="link" href="#basics">&#128279;</a> Cards</p>
                <p className="text md gray"> Cards are a convenient way to display content composed of different types of objects. They’re
                also well-suited for presenting similar objects whose size or supported actions can vary
                    considerably, like photos with captions of variable length. </p>
                <p className="text md mt-5">How to build a simple card:</p>
                <ol>
                    <li>Create a <code>div</code> and add class <code>card</code></li>
                    <li>Add one of the following classes to <code>div</code>:<code>half,wide</code> this
                            will defined its width</li>
                    <li>Inside the parent tag element add 3 <code>div</code> elements having following classes:
                            <code>.header, .body, .footer</code>
                    </li>
                </ol>
                <div className='row align-items-center py-2'>
                    <div className="col auto">
                        <Snippet code={card} language='html' />
                    </div>
                    <div className="col auto">
                        <div className="card">
                            <div className="header">
                                <p className="text lg bold"><code>poke-card</code></p>
                            </div>
                            <div className="body">
                                <p className="text sm"> .this card will take the width of its content. </p>
                            </div>
                            <div className="footer">
                                <p className="text md bold right">footer</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* SIZES */}
            <div className="container fluid py-1" id="sizes">

                <div className="container fluid p-2">
                    <p className="text xl"><a className="link" href="#sizes">&#128279;</a> Sizes</p>
                    <p className="text md"> We can apply different sizes to these cards, respectively: </p>
                    <ul>
                        <li><code>half</code> -- width: 50% - 20px</li>
                        <li><code>wide</code> -- width: 100% - 20px</li>
                    </ul>
                </div>
                <div className="container fluid">

                    <div className="card half">
                        <div className="header">
                            <p className="text lg bold"><code>div.card.half</code></p>
                        </div>
                        <div className="body">
                            <div className="container fluid">
                                <Snippet code={cardHalf} language='html' />
                            </div>
                        </div>
                        <div className="footer">
                            <p className="text md bold right">footer</p>
                        </div>
                    </div>

                    <div className="card wide">
                        <div className="header">
                            <p className="text lg bold"><code>div.card.wide</code></p>
                        </div>
                        <div className="body">
                            <div className="container fluid">
                                <Snippet code={cardWide} language='html' />
                            </div>
                        </div>
                        <div className="footer">
                            <p className="text md bold right">footer</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* SIZES ENDS HERE */}

            {/* AUTO */}
            <div className="container fluid py-3" id="auto">

                <div className="container fluid p-2">
                    <p className="text xl"><a href="#auto" className="link">&#128279;</a> Auto</p>
                    <p className="text md"> By adding <code>auto</code> class to <code>poke-card</code> element will set margin left and right property to <code>auto</code>. </p>
                </div>

                <div className='row'>
                    <div className='col auto'>
                        <div className="container sm">
                            <Snippet code={auto} language='html' />
                        </div>
                    </div>
                    <div className='col auto'>
                        <div className="container fluid my-2 p-2 border-dark">
                            <div className="card auto">
                                <div className="header">
                                    <p className="text lg bold"><code>poke-card</code></p>
                                </div>
                                <div className="body">
                                    <p className="text sm"> .this card will place itself on center </p>
                                </div>
                                <div className="footer">
                                    <p className="text md bold right">footer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {/* AUTO ENDS HERE */}

            {/* ROW */}
            <div className="container fluid py-3" id="row">

                <div className="container fluid">
                    <p className="text xl"><a href="#row" className="link">&#128279;</a> Card row</p>
                    <p className="text md gray"> Cards grouped by row can be implemented using two methods as <code>.card-row</code> will only place the cards on rows without making them responsive, on the other hand <code>.card-responsive-row</code> will not only place them on row but will force responsive layout for these, shrink the width size of the browser to spot the differences between these two methods. </p>
                </div>

                <div className="container fluid my-5">
                    <p className="text right bold">wrapper: <span className="badge lg gradient primary"><code>div.card-row</code></span> </p>
                    <div className="card-row border-dark">
                        {<div className='card' dangerouslySetInnerHTML={{ __html: literal }}></div>}
                        {<div className='card' dangerouslySetInnerHTML={{ __html: literal }}></div>}
                        {<div className='card' dangerouslySetInnerHTML={{ __html: literal }}></div>}
                    </div>

                </div>

                <div className="container fluid my-5">
                    <p className="text right bold">wrapper: <span className="badge lg gradient primary"><code>div.card-row.responsive</code> </span> </p>
                    <div className="card-row responsive border-dark">
                        {<div className='card' dangerouslySetInnerHTML={{ __html: literal }}></div>}
                        {<div className='card' dangerouslySetInnerHTML={{ __html: literal }}></div>}
                        {<div className='card' dangerouslySetInnerHTML={{ __html: literal }}></div>}
                    </div>

                </div>
            </div>
            {/* ROW ENDS HERE */}


            {/* IMAGE HEADER */}
            <div className="container fluid py-3" id="image-header">

                <div className="container fluid p-2">
                    <p className="text xl"><a href="#image-header" className="link">&#128279;</a> Image Header </p>
                    <p className="text md"> To add image we need to replace the <code>.header</code> element from inside of card wrapper with <code>.header-image</code> which will wrap around the image nicely, see example inside of the card below. </p>
                </div>

                <div className="container fluid">
                    <div className="card half auto">
                        <div className="header img">
                            <img src="https://images.pexels.com/photos/416179/pexels-photo-416179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" alt="bird" />
                        </div>
                        <div className="body">
                            <Snippet code={imageHeader} language='html' />
                        </div>
                        <div className="footer">card.half.auto</div>
                    </div>
                </div>

            </div>
            {/* IMAGE HEADER ENDS HERE */}

            {/* FULL IMAGE */}
            <div className="container fluid py-3" id='image'>
                <div className="container fluid p-2">
                    <p className="text xl"><a href="#image" className="link">&#128279;</a> Image Card </p>
                    <p className="text md">Full image cards are implemented by having two <code>div</code> inside the parent element, such as: </p>
                    <ol>
                        <li><code>div.full-img</code></li>
                        <li><code>div.caption</code></li>
                        <ul>
                            <li><code>div.message</code></li>
                        </ul>
                    </ol>
                </div>

                <div className='row align-items-center'>
                    <div className='col auto'>
                        <div className="container sm">
                            <Snippet code={imageFull} language='html' />
                        </div>
                    </div>
                    <div className='col auto'>
                        <div className="card auto">
                            <div className="full-img">
                                <img src="https://images.pexels.com/photos/151511/pexels-photo-151511.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" alt="eagle" />
                            </div>
                            <div className="caption">
                                <div className="message">
                                    <p className="text xl">Eagle</p>
                                    <p className="text md"> Eagle is the common name for many large birds of prey of the family Accipitridae. Eagles belong to several groups of genera, some of which are closely related. Most of the 60 species of eagle are from Eurasia and Africa. Outside this area, just 14 species can be found—2 in North America, 9 in Central and South America, and 3 in Australia.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* FULL IMAGE ENDS HERE */}

            {/* GLASS EFFECT */}
            <div className="container fluid py-3" id="glass-effect">

                <div className="container fluid p-2">
                    <div className="container fluid space-between align-items-center">
                        <p className="text xl"><a className="link" href="#glass-effect">&#128279;</a> Glass effect </p>
                        <div className="row">
                            <span className="badge lg gradient primary">#glass-effect</span>
                        </div>
                    </div>
                    <p className="text md"> Glass effect is applied for these cards by adding class <code>.glass</code> to the external container of each one of these. </p>
                </div>

                <div className='card-row img-bg p-5 text-success'>
                    {<div className='card glass' dangerouslySetInnerHTML={{ __html: effectLiteral }}></div>}
                    {<div className='card glass' dangerouslySetInnerHTML={{ __html: effectLiteral }}></div>}
                    {<div className='card glass' dangerouslySetInnerHTML={{ __html: effectLiteral }}></div>}
                </div>

            </div>
            {/* GLASS EFFECT ENDS HERE */}

        </div>
    </div>
}

export default Card